import config from '../config/configureEnv';
import { ajax, getUserAuthDataFromLocalStorage } from '../utils';

export default {
  signUp: userData => ajax('POST', `${config.bocaAPIUrl}/users`, {
    data: JSON.stringify(userData),
  }),

  logIn: (email, password) => ajax('POST', `${config.bocaAPIUrl}/users/login`, {
    data: JSON.stringify({
      email,
      password,
    }),
  }),

  logOut: () => {
    const { accessToken } = getUserAuthDataFromLocalStorage();

    return ajax('POST', `${config.bocaAPIUrl}/users/logout`, {
      urlParams: { access_token: accessToken },
    });
  },

  checkAccessTokenExists: () => {
    const { accessToken } = getUserAuthDataFromLocalStorage();

    return ajax('HEAD', `${config.bocaAPIUrl}/AccessTokens/${accessToken}`, {
      urlParams: { access_token: accessToken },
    });
  },

  getUser: () => {
    const {
      accessToken,
      userId,
    } = getUserAuthDataFromLocalStorage();

    return ajax('GET', `${config.bocaAPIUrl}/users/${userId}`, {
      urlParams: { access_token: accessToken },
    });
  },

  createUser: (userData) => {
    const { accessToken } = getUserAuthDataFromLocalStorage();

    return ajax('POST', `${config.bocaAPIUrl}/users`, {
      urlParams: { access_token: accessToken },
      data: JSON.stringify(userData),
    });
  },

  updateUser: (userData) => {
    const {
      accessToken,
      userId,
    } = getUserAuthDataFromLocalStorage();

    return ajax('PATCH', `${config.bocaAPIUrl}/users/${userId}`, {
      urlParams: { access_token: accessToken },
      data: JSON.stringify(userData),
    });
  },

  uploadUserPhoto: (formData) => {
    const {
      accessToken,
      userId,
    } = getUserAuthDataFromLocalStorage();

    return ajax('POST', `${config.bocaAPIUrl}/users/${userId}/photos`, {
      urlParams: { access_token: accessToken },
      cache: false,
      contentType: false,
      processData: false,
      data: formData,
    });
  },

  deactivateUser: (userId) => {
    const { accessToken } = getUserAuthDataFromLocalStorage();

    return ajax('DELETE', `${config.bocaAPIUrl}/users/${userId}`, {
      urlParams: { access_token: accessToken },
    });
  },

  getJoinedTeamList: () => {
    const { accessToken } = getUserAuthDataFromLocalStorage();

    return ajax('GET', `${config.bocaAPIUrl}/users/teams`, {
      urlParams: { access_token: accessToken },
    });
  },

  quickSignup: userData => ajax('POST', `${config.bocaAPIUrl}/quick-signups`, {
    data: JSON.stringify(userData),
  }),

  getSignupList: () => {
    const { accessToken } = getUserAuthDataFromLocalStorage();

    return ajax('GET', `${config.bocaAPIUrl}/quick-signups`, {
      urlParams: { access_token: accessToken },
    });
  },

  approveSignup: (userData) => {
    const { accessToken } = getUserAuthDataFromLocalStorage();

    return ajax('POST', `${config.bocaAPIUrl}/quick-signups/approve`, {
      urlParams: { access_token: accessToken },
      data: JSON.stringify(userData),
    });
  },

  declineSignup: (id) => {
    const { accessToken } = getUserAuthDataFromLocalStorage();

    return ajax('GET', `${config.bocaAPIUrl}/quick-signups/${id}/decline`, {
      urlParams: { access_token: accessToken },
    });
  },

  getCheckoutToken: (teamId, planKey) => {
    const { accessToken } = getUserAuthDataFromLocalStorage();

    return ajax('POST', `${config.bocaAPIUrl}/subscriptions/checkoutToken/team/${teamId}`, {
      urlParams: { access_token: accessToken },
      data: JSON.stringify({ planKey }),
    });
  },

  requestDemo: (userData) => {
    const { accessToken } = getUserAuthDataFromLocalStorage();

    return ajax('POST', `${config.bocaAPIUrl}/demo-requests`, {
      urlParams: { access_token: accessToken },
      data: JSON.stringify(userData),
    });
  },
};



// WEBPACK FOOTER //
// ./src/api/UserAPIConnectors.js